import { sanitizeUrl } from '@braintree/sanitize-url';
import Link from '@mui/material/Link';
import type { Variant } from '@mui/material/styles/createTypography';
import Typography from '@mui/material/Typography';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import React from 'react';
import { useSelector } from 'react-redux';

interface ComponentProps {
  variant?: Variant;
}

function ContactInfo({ variant }: ComponentProps) {
  const configuration = useSelector((state: ApplicationState) => state.configuration.configuration);

  return (
    <Typography variant={variant || 'body2'}>
      {[
        'Contact ',
        configuration.admin_email ? (
          <Link
            key="emailLink"
            href={sanitizeUrl(`mailto:${configuration.admin_email}`)}
          >
            {configuration.admin_email}
          </Link>
        ) : 'the administrator',
        ...(configuration.application_admin_url ? [
          ' or visit ',
          <Link
            key="urlLink"
            href={sanitizeUrl(configuration.application_admin_url)}
            target="_blank"
          >
            the help page
          </Link>,
        ] : []),
        ' for assistance.',
      ]}
    </Typography>
  );
}

export default ContactInfo;
